import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import 'core-js/es6/array';
import 'core-js/es7/array';

//Importing custom components
import {WrappperComponent} from './shell/wrapper/wrapper.component';
import {ScalingComponent} from './shell/scaling/scaling.component';
import { SliderControllerComponent} from './shell/slider_controller/slider_controller.component';
import {PreloadComponent} from './shell/preload/preload.component';
import { InteractiveComponent } from './components/interactivity/interactivity.component';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppGlobals } from './shared/app.global';
import { AudioControllerComponent } from './shell/audio_controller/audio_controller.component';
import { SpriteControllerComponent } from './shell/sprite_controller/sprite_controller.component';
import { VideoControllerComponent } from './shell/video_controller/video_controller.component';
import { ClickDirective } from './shared/directive/click.directive';
import { KeysPipe } from './shared/pipes';
import { StripHtmlPipe } from './shared/pipes';
import { interActivityServices } from './shared/services/interactivity.services';

//Importing custom components End>


@NgModule({
  declarations: [
    WrappperComponent,
    PreloadComponent,
    InteractiveComponent,
    KeysPipe,
    StripHtmlPipe,
    VideoControllerComponent,
    ClickDirective,
  ],
  imports: [
    BrowserModule,BrowserAnimationsModule,HttpModule      
  ],
  providers: [ClickDirective, ScalingComponent, AppGlobals, InteractiveComponent, AudioControllerComponent, VideoControllerComponent, SpriteControllerComponent, SliderControllerComponent, interActivityServices],
  bootstrap: [WrappperComponent]
})
export class AppModule { }
